import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {WriteWorktimeForm} from "@/pages/Worktime/WriteWorktime";
import {PlanPO, ReviewPO, TaskPO, WorktimePO} from "@/model/mission";

export enum WorktimeEnum {
    GetWorktimePage = "/worktime/getWorktimePage",
    GetWorktime = "/worktime/getWorktime",
    CreateWorktime = "/worktime/createWorktime",
}

export interface WorktimePageBO {
    keyword?: string;
}

export interface WorktimePageVO extends WorktimePO {
    planName: string;
    executor: string;
    virtue: string;
    virtueId: number;
    priority: string;
    executorId: number
    priorityId: number;
    taskName: string;
    reviewerId: number;
    duration: number;
    status: number;
}

export interface WorktimeVO extends WorktimePO {
    task: TaskPO
    plan: PlanPO
    review: ReviewPO
}

export const useQueryWorktimePage = () => useMutation<BaseVO<PaginationVO<WorktimePageVO>>, null, WorktimePageBO>({
    mutationFn: (data: WorktimePageBO) => http.post<BaseVO<PaginationVO<WorktimePageVO>>>({
        url: WorktimeEnum.GetWorktimePage,
        data: data,
    }),
})

export const useQueryWorktime = (params: GetByIdBO, enabled: boolean) => useQuery<BaseVO<WorktimeVO>>({
    queryKey: [params.id], enabled, queryFn: () => http.get<BaseVO<WorktimeVO>>({
        url: WorktimeEnum.GetWorktime,
        params: params
    })
})

export const useCreateWorktime = () => useMutation({
    mutationFn: (data: WriteWorktimeForm) => http.put<BaseVO<null>>({url: WorktimeEnum.CreateWorktime, data}),
})




